module.exports = function() {
  return new Worker(__webpack_public_path__ + "286e210d833d81377975.worker.js");
};